import { Buffer } from 'buffer';
import { createHash } from 'crypto-browserify';

const client: { id: string; secret: string } = {
  id: process.env.REACT_APP_API_CLIENT_ID as string,
  secret: process.env.REACT_APP_API_CLIENT_SECRET as string,
};

const getBasicToken = () => {
  const ts = Date.now();
  const encryptSecret = createHash('md5')
    .update(client.secret + ts)
    .digest('hex');
  return Buffer.from(`${client.id}:${encryptSecret}|${ts}`).toString('base64');
};

export default getBasicToken;
